import DefaultLayout from "./containers/DefaultLayout";


//phr
import PhrTab from './views/PersonalHealthRecord/PhrTab';
import EditProfile from './views/Account/EditProfile';
import AccountSetting from './views/Account/AccountSetting'
import PostTab from './views/Blog/Post/PostTab'
import Ovulation from './views/HealthTools/Ovulation/Ovulation'
import KickCounter from './views/HealthTools/KickCounter/KickCounter';
import WeightGain from './views/HealthTools/WeightGain/WeightGain';
import GrowthTracker from './views/HealthTools/GrowthTracker/GrowthTracker';
import ComingSoon from "./views/ComingSoon";
// import ViewSharemyrecord  from './views/PersonalHealthRecord/ShareMyRecord/ViewSharemyrecord';
import Dashboard from './views/Dashboard/Dashboard';
import BookedServices from './views/BookedServices/BookedServices'

// const Dashboard = Loadable({
//   loader: () => import("./views/Dashboard"),
//   loading: Loading
// });

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: "/", name: "Home", component: DefaultLayout, exact: true },
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  //phr
  {path:'/personalhealthrecord', name:'Personal Health Record', component:PhrTab },
  // {path: "/pregnancyvitalrecord", name: "Add Pregnancy Vital", component: AddVitals },
  //MomDiary
  // { path: "/momdiary", name: "Mom's Diary", component: MomDiary },
  // { path: "/addmomdiary", name: "Add New Diary", component: MomDiaryRecord },
  // {path:'/editmomdiary/:id', name:"Edit Diary", component:EditMomDiary},
  // {path:'/diary/:id', name:"Dairy" , component : Diary},
  //pregnancyvitals
  // {path:'/pregnancyvitals', name:'Pregnancy Vitals', component:ViewPregnancyVitalsThyroid},
  // {path:'/addpregnancyVitals', name:' Add Pregnancy Vitals', component:AddPregnancyVitals},
  // {path:'/addgeneralmedicalrecord', name:'Add Medical Record', component: MedicalRecord},
  // {path:'/generalmedicalrecord', name:'View Medical Record', component:ViewMedicalrecord},
  // {path: '/editmedicalrecord/:id', name: 'Edit medical reocrd', component: EditMedicalRecord },
  // {path:'/childrecord', name:'Child Record', component:ViewChildrecord},
  // {path:'/addchildrecord', name:'Add Child Record', component: ChildRecord},
  // {path: '/editchildrecord/:id', name: 'Edit Child Record', component: EditChildRecord},
  {path:'/accountsetting', name:'Account Setting', component:AccountSetting},
  // {path:'/pregnancyrecord', name:"Pregnancy  Record",  component:ViewpregnancyRecord},
  // {path:'/addpregnancyrecord', name:'Add New Pregnancy Record', component: PregnancyRecord},
  // {path: '/editpregnancyrecord/:id', name:'Edit Pregnnacy Record', component: EditPregnancyRecord},
  {path:'/profile', name:'My Profile', component:EditProfile},
  // {path:'/servicebooking', name:' Service Bookings', component:ViewServiceBooking},
  // {path:'/sharemyrecord', name:'Share My Record', component:ViewSharemyrecord},
  // {path:'/addnewdocument', name:'Add new Document', component:AddnewDocument},
  //Blog PostTableView
  // {path:'/post', name:'PostTableView', component:PostTableView},
  // {path:'/addblogpost', name:'Add New  PostTableView', component:AddBlogPost},
  // {path:'/editblogpost/:id', name:'Edit PostTableView', component:EditBlogPost},
  {path:'/blog', name:"Blog", component:PostTab},
  // {path:'/viewblog', name:"View Blog", component:ViewBlog},
  // {path:'/aboutme', name:"About Me" , component:AboutMe},
  // {path:'/editblog/:id', name:"Edit Blog", component:EditBlogPost},
  //Health Tools
  {path:'/ovulationcalculator', name:'Ovulation Calculator', component:Ovulation},
  {path :'/kickcounter', name:'Kick Counter', component:KickCounter},
  {path:'/babygrowthcalculator', name:'Baby Grwoth Calculator', component: GrowthTracker},
  {path: '/childdevelopment', name: '', component: ComingSoon },
  {path: '/weightgain', component: WeightGain },
  {path: '/booked-services', component: BookedServices },
  // {path: '/edit-vitals/:id', name: 'Edit Vitals', component: EditVital },
  // {path: '/edit-thyroid-vital/:id', name: 'Edit Thyroid Pregnancy Vital', component: EditThyroidVital},
  // {path: '/edit-blood-sugar-vital/:id', name: 'Edit Thyroid Sugar Vital', component: EditBloodSugarVital},
  // {path: '/edit-blood-pressure-vital/:id', name: 'Edit Blood Pressure Pregnancy Vital', component: EditBloodPressureVital},
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js